import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaFacebookF, FaUserCircle, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const Footer = () => {
  const [contactData, setContactData] = useState(null);
  const [logoUrl, setLogoUrl] = useState("https://i.postimg.cc/Hn0bj73Y/footer-Logo.png"); // fallback logo
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Listen to auth state
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });

    const fetchContactInfo = async () => {
      try {
        const docRef = doc(db, "contactInfo", "siteContact");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContactData(docSnap.data());
        } else {
          // Try old document ID as fallback
          const oldDocRef = doc(db, "contactInfo", "eLEZFK77BPlj1ftNTRc");
          const oldDocSnap = await getDoc(oldDocRef);
          if (oldDocSnap.exists()) {
            setContactData(oldDocSnap.data());
          } else {
            setError("No contact info found!");
          }
        }
      } catch (err) {
        console.error(err);
        setError("Error fetching contact info!");
      } finally {
        setLoading(false);
      }
    };

    const fetchLogo = async () => {
      try {
        const docRef = doc(db, "logos", "xrSCDlcVzp10becG8bnW");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          // First try footerLogo (from SiteSettings)
          if (data.footerLogo) {
            setLogoUrl(data.footerLogo);
          } 
          // Then try "footer logo" (old format)
          else if (data["footer logo"]) {
            setLogoUrl(data["footer logo"]);
          }
        }
      } catch (err) {
        console.error("Error fetching logo:", err);
      }
    };

    fetchContactInfo();
    fetchLogo();

    return () => unsubscribe(); // cleanup listener
  }, []);

  return (
<footer>
      <div className="footer-section">
        <div className="footer-wrapper">
          {/* Logo - Cloudinary URL from Firestore */}
          <div className="footer-logo">
            <img src={logoUrl} alt="VisionBird Footer Logo" />
          </div>

          {/* Grid Section */}
          <div className="Grip-4-box">
            {/* Company Links */}
            <div className="footer-page">
              <h1>COMPANY</h1>
              <div className="footer-links">
                <Link id="navbutton" to="/">HOME</Link>
                <Link id="navbutton" to="/About">ABOUT</Link>
                {/* <Link id="navbutton" to="/Services">SERVICES</Link> */}
                <Link id="navbutton" to="/CertifcatePage">REGISTERATION</Link>
                <Link id="navbutton" to="/Career">CAREER</Link>
                <Link id="navbutton" to="/ApplyForJob">JOIN OUR TEAM</Link>
                <Link id="navbutton" to="/Future-Reservation">SLOT RESERVATION</Link>
                <Link id="navbutton" to="/Contact">CONTACT</Link>
              </div>
            </div>

            {/* Services Links */}
            <div className="footer-page">
              <h1>SERVICES</h1>
              <div className="footer-links">
                <Link id="navbutton" to="/WebServic">WEB DEVELOPMENT</Link>
                <Link id="navbutton" to="/GraphicServic">GRAPHIC DESIGNING</Link>
                <Link id="navbutton" to="/MotionServic">MOTION GRAPHICS</Link>
              </div>
            </div>

            {/* Google Map */}
            <div className="footer-page">
              <h1>HOW TO FIND US</h1>
              <div className="find-us">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3077.1080940015236!2d74.06448677516326!3d32.58965099353867!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391f1ad2ec5c194b%3A0x3e141a53d0c02f1d!2sVisionBird%20Technologies%20(Software%20House)!5e1!3m2!1sen!2s!4v1754001644174!5m2!1sen!2s"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="VisionBird Location"
                ></iframe>
              </div>
            </div>

            {/* Contact Info - From Firestore */}
            <div className="footer-page">
              <h1>CONTACT US</h1>
              {loading && <p>Loading contact info...</p>}
              {error && <p style={{ color: "red" }}>{error}</p>}
              {contactData && (
                <pre style={{ fontFamily: "inherit", margin: 0 }}>
                  <b>Email:</b> {contactData.email || contactData.firstEmail || contactData["first email"]} <br />
                  <b>Landline:</b> {contactData.landline || contactData.phoneOne || contactData["phone one"]} <br />
                  <b>Mobile:</b> {contactData.mobile || contactData.phoneTwo || contactData["phone two"]} <br />

                  {/* Announcement */}
                  {contactData.officeTimings || contactData["office timings"]} <br />  
                  <b>Address:</b> {contactData.address}
                </pre>
              )}
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="buttombar">
            <div className="main">
              <div id="right">
                <p>© 2026, VisionBird Technologies.</p>
                <p>All Rights Reserved.</p>
                <p>
                  <Link to="/Privacy">Privacy Policy</Link> |{" "}
                  <Link to="/Cookies">Cookies Policy</Link>
                </p>
              </div>

              <div id="action-land">
                {/* Facebook */}
                <div className="user-land">
                  <a href="https://www.facebook.com/VisionBirdTech" target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                </div>

                {/* Instagram */}
                <div className="user-land">
                  <a href="https://www.instagram.com/visionbirdtechnologies/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </div>

                {/* X (Twitter) */}
                <div className="user-land">
                  <a href="https://x.com/VisionbirdT" target="_blank" rel="noopener noreferrer">
                    <FaXTwitter />
                  </a>
                </div>

                {/* LinkedIn */}
                <div className="user-land">
                  <a href="https://www.linkedin.com/in/visionbird/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                </div>

                {/* WhatsApp */}
                <div className="user-land">
                  <a href="https://api.whatsapp.com/send?phone=923016239096&text=VisionBirdTechnologies" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp />
                  </a>
                </div>

                {/* Admin Panel / User Account */}
                <div className="user-land">
                  <Link to={isLoggedIn ? "/admin" : "/login"}>
                    <FaUserCircle />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Hidden App Version Tag for Dev Inspection */}
          <div 
            style={{ 
              opacity: 0.02, 
              fontSize: "10px", 
              textAlign: "center", 
              userSelect: "none", 
              pointerEvents: "none" 
            }}
          >
            production : V2.3.0
          </div>

        </div>
      </div>
    </footer>

  );
};

export default Footer;